import PropTypes from 'prop-types'
import { useState } from 'react'
import { Button, ButtonGroup, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react'
import { useAppContext } from 'hooks/useAppContext'
import { checkPassword } from 'api'

export const ModalPasswordConfirmation = ({ isOpen, onClose, heading, btnConfirmLabel = 'Confirm', btnCancelLabel = 'Cancel', onConfirm }) => {
  const { createToast } = useAppContext()
  const [password, setPassword] = useState('')

  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleConfirm = async (content) => {
    if (!password) {
      createToast('warning', 'Input password.')
      return
    }

    setIsSubmitting(true)

    try {
      await checkPassword(password)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
      return
    }

    try {
      await onConfirm()
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  const handleChange = (e) => { setPassword(e.target.value) }

  return (
    <>
      <Modal size="xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{heading}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl isRequired>
              <FormLabel>Enter password below to continue.</FormLabel>
              <Input type="password" name="password" value={password} onChange={handleChange} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <ButtonGroup gap={4}>
              <Button colorScheme="blue" size="sm" onClick={handleConfirm} isLoading={isSubmitting}>{btnConfirmLabel}</Button>
              <Button variant="ghost" colorScheme="gray" size="sm" onClick={onClose}>{btnCancelLabel}</Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

ModalPasswordConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  heading: PropTypes.string,
  btnConfirmLabel: PropTypes.string,
  btnCancelLabel: PropTypes.string,
  onConfirm: PropTypes.func
}
